// configs/index.js
import { getSiteConfig } from './sub-site/index'

const currentSite = process.env.SITE_NAME || 'nxhzz'
const siteConfig = getSiteConfig()

export default {
  site: currentSite,
  head: siteConfig.head,
  plugins: {
    element: true,
    myComs: true,
    vuexStorage: false,
    jquery: true,
    sentry: false,
    cnzz: false
  },
  proxy: siteConfig.proxy,
}